import { createFileRoute } from "@tanstack/react-router";
import { KontaktPage, kontaktHead } from "@/pages/KontaktPage";

export const Route = createFileRoute("/en/contact-mi-support")({
  head: () => kontaktHead("en"),
  component: () => <KontaktPage locale="en" />,
});
